import { useEffect, useState } from 'react';
import PageHero from '@/components/PageHero';
import '../styles/contact.css';

const CONTACTS = [
  {
    label: '运营主体',
    value: '武汉高灏科技有限责任公司',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M3 21h18M5 21V7l7-4 7 4v14M9 21v-6h6v6" />
      </svg>
    ),
  },
  {
    label: '业务咨询',
    value: '请通过下方留言表单提交，我们按留言内容对接',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M21 15a2 2 0 0 1-2 2H8l-5 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
    ),
  },
  {
    label: '平台入口',
    value: '交易市场 trade.yunniuji.com · 监管平台 transport.yunniuji.com',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18" />
      </svg>
    ),
  },
];

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');

  useEffect(() => {
    document.title = '联系我们 | 云牛集·山东牛产业智慧平台';
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (submitting) return;

    const form = new FormData(e.currentTarget);
    const payload = {
      name: String(form.get('name') || '').trim(),
      phone: String(form.get('phone') || '').trim(),
      org: String(form.get('org') || '').trim(),
      email: String(form.get('email') || '').trim(),
      message: String(form.get('message') || '').trim(),
      website: String(form.get('website') || '').trim(),
    };

    setSubmitting(true);
    setSubmitError('');

    try {
      const res = await fetch('/api/v1/public/inquiries', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      let body: { code?: number; message?: string } = {};
      try {
        body = await res.json();
      } catch {
        body = {};
      }

      if (!res.ok || (body.code !== undefined && body.code !== 0)) {
        throw new Error(body.message || `提交失败（${res.status}），请稍后重试或直接电话联系`);
      }

      setSubmitted(true);
      e.currentTarget.reset();
    } catch (err) {
      setSubmitError(err instanceof Error ? err.message : '提交失败，请稍后重试');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <PageHero
        title="联系我们"
        desc="无论是合作洽谈、业务咨询还是意见反馈，欢迎随时与我们联系。"
      />

      <section className="section">
        <div className="container contact-wrap">
          <div className="contact-info">
            <div className="section-head left">
              <h2>联系方式</h2>
              <p className="section-desc">
                合作、采购、入驻或媒体垂询，请通过以下方式与我们取得联系
              </p>
            </div>
            <ul className="contact-list">
              {CONTACTS.map((item) => (
                <li key={item.label} className="contact-item">
                  <span className="contact-icon">{item.icon}</span>
                  <div>
                    <strong>{item.label}</strong>
                    <p>{item.value}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="contact-form-card">
            {submitted ? (
              <div className="form-success">
                <span className="success-mark">✓</span>
                <h3>留言已收到</h3>
                <p>我们已记录您的信息，会在 1-2 个工作日内与您联系。</p>
                <button
                  type="button"
                  className="btn btn-ghost btn-sm"
                  onClick={() => setSubmitted(false)}
                >
                  再填一次
                </button>
              </div>
            ) : (
              <>
                <h3>在线留言</h3>
                <p className="form-tip">
                  请填写以下信息，我们将在 1-2 个工作日内回复
                </p>
                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-row">
                    <label htmlFor="cf-name">
                      姓名 <span>*</span>
                    </label>
                    <input
                      id="cf-name"
                      name="name"
                      type="text"
                      required
                      maxLength={64}
                      placeholder="您的姓名"
                    />
                  </div>
                  <div className="form-row">
                    <label htmlFor="cf-org">单位名称</label>
                    <input
                      id="cf-org"
                      name="org"
                      type="text"
                      maxLength={128}
                      placeholder="所在企业 / 政府部门"
                    />
                  </div>
                  <div className="form-row">
                    <label htmlFor="cf-phone">
                      联系方式 <span>*</span>
                    </label>
                    <input
                      id="cf-phone"
                      name="phone"
                      type="tel"
                      required
                      maxLength={32}
                      placeholder="手机号 / 电话"
                    />
                  </div>
                  <div className="form-row">
                    <label htmlFor="cf-email">邮箱</label>
                    <input id="cf-email" name="email" type="email" maxLength={128} placeholder="you@example.com" />
                  </div>
                  <div className="form-row">
                    <label htmlFor="cf-msg">
                      留言内容 <span>*</span>
                    </label>
                    <textarea
                      id="cf-msg"
                      name="message"
                      rows={5}
                      required
                      minLength={5}
                      maxLength={2000}
                      placeholder="请简要描述您的需求"
                    />
                  </div>

                  {/* 反机器人字段：正常用户看不到、不会填写 */}
                  <input
                    className="form-hp"
                    type="text"
                    name="website"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                  />

                  {submitError ? (
                    <p className="form-error" role="alert">
                      {submitError}
                    </p>
                  ) : null}

                  <button type="submit" className="btn btn-teal form-submit" disabled={submitting}>
                    {submitting ? '提交中…' : '提交留言'}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
